export const VERBIAGE = {
  digital: 'Digital',
  Physical: 'Physical'
};

export const TITLE = {
  homeDepot: 'The Home Depot ',
  specialty: 'Specialty '
};

export const BREAK_POINTS = {
  sm: {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 16
  },
  md: {
    slidesPerView: 3,
    slidesPerGroup: 3,
    spaceBetween: 24
  },
  lg: {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 24
  },
  xl: {
    slidesPerView: 5,
    slidesPerGroup: 5,
    spaceBetween: 32
  }
};